import { create } from 'zustand'
import fetcher from "../fetcher";

export const useClientsStore = create((set, get) => ({
    clients: [],
    has_more: true,
    loading: false,
    current_page: 0,
    count: 0,
    total_monthly_profit: 0,

    search: "",
    setSearch: (value) => set(() => ({search: value})),

    fetchListClients: async (params) => {
        set({loading: true})
        const response = await fetcher.getClients(params)
        if (response?.data) {
            const { results, has_more, current_page, count, total_monthly_profit } = response?.data

            if (current_page === 1) {
                set({
                    clients: results,
                    loading: false,
                    has_more: has_more,
                    current_page: current_page,
                    count: count,
                    total_monthly_profit: total_monthly_profit
                })
            } else {
                const currentPage = get().current_page
                if (current_page !== currentPage) {
                    const currentList = get().clients

                    const newList = currentList.concat(results)
                    set({
                        clients: newList,
                        loading: false,
                        has_more: has_more,
                        current_page: current_page,
                        count: count,
                        total_monthly_profit: total_monthly_profit
                    })
                }
            }
        }
    },
    shouldFetchNextClients: () => {
        return !Boolean(get().loading) && Boolean(get().has_more)
    },

    removeDeletedClientFromList: (clientId) =>
        set((state) => ({
            clients: state.clients.filter((client) => client.id !== clientId),
        })),

    addCreatedClientToList: (newClient) =>
        set((state) => ({
            clients: [newClient, ...state.clients],
        })),
}))